<template>
    <main>
        <div class="relative min-h-screen flex flex-col">
            <slot />
        </div>
    </main>
</template>

<script lang="ts" setup></script>
